<template>
<v-data-table :headers="headers" :items="items">
    <template v-slot:items="{ item }">
        <td>{{ item.Name }}</td>
        <td>{{ item.IsActive ? 'Active' : 'Inactive' }}</td>
        <td>
            <v-btn color="primary" block @click="$emit('edit', item)">
                <span>Edit</span>
            </v-btn>
        </td>
    </template>
</v-data-table>
</template>

<script>
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            rules: validationRules.rules,
            edit: false,
            headers: [
                {
                    text: "Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Active Status",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "PestClassificationTypeID",
                    sortable: false
                }
            ]
        }
    }
}
</script>
